<template>
    <div>
        <el-form :model="vo" @submit.native.prevent>
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_学号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'studentId'" class="field">学号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="studentId"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入学号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 8, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '学号', propName: 'studentId', propType: 'String', textFormatter: 'textfield', valueMaxLength: 200, valueMinLength: null, model: 'vo.studentId', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_姓名" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'name'" class="field">姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="name"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入姓名', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 8, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '姓名', propName: 'name', propType: 'String', textFormatter: 'textfield', valueMaxLength: 5, valueMinLength: null, model: 'vo.name', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_学籍编号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'studentFileId'" class="field">学籍编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="studentFileId"
                                        :field="{ defaultValue: null, elementCanEdit: '0', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入学籍编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 8, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '学籍编号', propName: 'studentFileId', propType: 'String', textFormatter: 'textfield', valueMaxLength: 50, valueMinLength: null, model: 'vo.studentFileId', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo" :can-edit="0" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_联系电话" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'mobilePhone'" class="field">联系电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="mobilePhone" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '联系电话',
                                        propName: 'mobilePhone',
                                        propType: 'String',
                                        textFormatter: 'phone',
                                        valueMaxLength: 100,
                                        valueMinLength: null,
                                        tbFieldName: 'mobilephone',
                                        iconName: 'sjhm',
                                        model: 'vo.mobilePhone',
                                        option: [],
                                        formTdAlign: 'text-left',
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_有无照片" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'hasPhoto'" class="field">有无照片</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" :colspan="vo.hasPhoto == 1 ? 1 : 3">
                                    <form-item ref="hasPhoto"
                                        :field="{ 'defaultValue': '0', 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': '1：有\n0：无', 'elementReadonly': 1, 'elementType': 'radio', 'emptyMessage': '', 'errorMessage': null, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '有无照片', 'propName': 'hasPhoto', 'propType': 'String', 'textFormatter': null, 'valueMaxLength': null, 'valueMinLength': null, 'tbFieldName': 'hasphoto', 'iconName': 'dxk', 'model': 'vo.hasPhoto', 'option': [{ 'value': '1', 'name': '有' }, { 'name': '无', 'value': '0' }], 'formTdAlign': 'text-left', 'optionGenerateType': 0, 'clearable': false, 'filterable': false, 'allowCreate': false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <template v-if="vo.hasPhoto==1" >
                                    <td ref="tdlbl_照片" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span v-field-lbl="'idPhoto'" class="field">学生照片</span>
                                    </td>
                                    <!-- <tr> -->
                                    <td class="el-table__cell tdcont tdw83" colspan="1">
                                        <form-item ref="idPhoto" :field="{'defaultValue':'photoUrl','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'file','emptyMessage':'请选择待上传图片','errorMessage':null,'isRequired':0,'onClickEvent':'','passenger':{},'propComment':'照片','propName':'idPhoto','propType':'byte[]','textFormatter':'.png, .jpg','valueMaxLength':255,'valueMinLength':null,'tbFieldName':'idphoto','iconName':'bzdtp','model':'vo.idPhoto','option':[],'downloadUrl':'xsgl/studentBasicInfo/download','formTdAlign':'text-left','formTdColspan':8,'nameField':'photoUrl','limitCount':null}" :vo="vo" :can-edit="canEdit"  />
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <td ref="tdlbl_证件类型" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'idType'" class="field">证件类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="idType" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：居民身份证（户口簿）\n1：香港特区护照/港澳居民来往内地通行证\n2：澳门特区护照/港澳居民来往内地通行证\n3：台湾居民来往大陆通行证\n4：外国人护照\n5：社会保障卡\n6：香港居民身份证\n7：澳门居民身份证\n8：台湾居民身份证',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择证件类型',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '证件类型',
                                        propName: 'idType',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 20,
                                        valueMinLength: null,
                                        model: 'vo.idType',
                                        option: [
                                            { value: '0', name: '居民身份证（户口簿）' },
                                            { value: '1', name: '香港特区护照/港澳居民来往内地通行证' },
                                            { value: '2', name: '澳门特区护照/港澳居民来往内地通行证' },
                                            { value: '3', name: '台湾居民来往大陆通行证' },
                                            { value: '4', name: '外国人护照' },
                                            { value: '5', name: '社会保障卡' },
                                            { value: '6', name: '香港居民身份证' },
                                            { value: '7', name: '澳门居民身份证' },
                                            { value: '8', name: '台湾居民身份证' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_证件号码" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'idCardNumber'" class="field">证件号码</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="idCardNumber" key="idCardNumber1" v-if="vo.idType == 0" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '证件号码',
                                        propName: 'idCardNumber',
                                        propType: 'String',
                                        textFormatter: 'card',
                                        valueMaxLength: 100,
                                        valueMinLength: null,
                                        tbFieldName: 'idcardnumber',
                                        iconName: 'shenfenzheng',
                                        model: 'vo.idCardNumber',
                                        option: [],
                                        formTdAlign: 'text-left',
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                    <form-item ref="idCardNumber" key="idCardNumber2" v-else :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '证件号码',
                                        propName: 'idCardNumber',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 100,
                                        valueMinLength: null,
                                        tbFieldName: 'idcardnumber',
                                        iconName: 'shenfenzheng',
                                        model: 'vo.idCardNumber',
                                        option: [],
                                        formTdAlign: 'text-left',
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_政治面貌" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'politicalStatus'" class="field">政治面貌</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="politicalStatus" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: politicalStatusFormat,
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择政治面貌',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '政治面貌',
                                        propName: 'politicalStatus',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 4,
                                        valueMinLength: null,
                                        model: 'vo.politicalStatus',
                                        option: politicalStatusOption,
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_性别" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'gender'" class="field">性别</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="gender" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '0',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：男\n1：女',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择性别',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '性别',
                                        propName: 'gender',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 4,
                                        valueMinLength: null,
                                        model: 'vo.gender',
                                        option: [
                                            { value: '0', name: '男' },
                                            { value: '1', name: '女' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_出生日期" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'birthDate'" class="field">出生日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="birthDate"
                                        :field="{ defaultValue: null, elementCanEdit: '0', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '', errorMessage: null, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '出生日期', propName: 'birthDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd', valueMaxLength: null, valueMinLength: null, tbFieldName: 'birthdate', iconName: 'sjxzk', model: 'vo.birthDate', option: [], formTdAlign: 'text-left', weekday: 0 }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_年龄" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'age'" class="field">年龄</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="age"
                                        :field="{ defaultValue: null, elementCanEdit: '0', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementType: 'input', emptyMessage: '', errorMessage: null, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '年龄', propName: 'age', propType: 'String', textFormatter: 'integer', valueMaxLength: 2, valueMinLength: null, tbFieldName: 'age', iconName: 'zhengshu', model: 'vo.age', option: [], formTdAlign: 'text-left', autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_招生年份" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">招生年份</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit == 1">
                                        <el-date-picker v-model="vo.admissionYear" type="year" placeholder="请选择"
                                            size="small" style="width: 100%" value-format="yyyy" />
                                    </div>
                                    <div v-if="canEdit == 0">
                                        {{ vo.admissionYear }}
                                    </div>
                                </td>
                                <td ref="tdlbl_招生季度" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'admissionSeason'" class="field">招生季度</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="admissionSeason" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：春季\n1：秋季',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择招生季度',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '招生季度',
                                        propName: 'admissionSeason',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.admissionSeason',
                                        option: [
                                            { value: '0', name: '春季' },
                                            { value: '1', name: '秋季' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_学制" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'educationSystem'" class="field">学制</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="educationSystem" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '1：二年\n2：三年\n3：四年\n4：五年\n5：六年',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '学制',
                                        propName: 'educationSystem',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'educationsystem',
                                        iconName: 'xialakuang',
                                        model: 'vo.educationSystem',
                                        option: [
                                            { value: '1', name: '二年' },
                                            { name: '三年', value: '2' },
                                            { name: '四年', value: '3' },
                                            { name: '五年', value: '4' },
                                            { name: '六年', value: '5' }
                                        ],
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_院系" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">院系</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div @click="selectType('majorCategory')">
                                        <el-input v-model="vo.majorCategory" v-listpage-dialog v-can-edit
                                            listviewurl="school.majors.listMain" dialog-title="选择专业"
                                            exclude-fields="createTime" retain-btns="" name="majorCategory"
                                            placeholder="请选择专业" />
                                    </div>
                                </td>
                                <td ref="tdlbl_专业大类" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">专业大类</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <!-- <div v-if="vo.majorCategory" @click="selectType('majorName')">
                                        <el-input
v-model="vo.majorName" v-listpage-dialog v-can-edit
                                            listviewurl="school.majors.list_FyvEGz" dialog-title="选择专业"
                                            exclude-fields="createTime" retain-btns="" name="majorName"
                                            placeholder="请选择专业"
/>
                                    </div> -->
                                    <div>
                                        <!-- <el-input
v-model="vo.majorName" readonly name="majorName"
                                            placeholder="请先选择专业大类"
/> -->
                                        <span>{{ vo.majorName }}</span>
                                    </div>
                                </td>

                                <td ref="tdlbl_专业小类" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">专业小类</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <!-- <div v-if="vo.majorName" @click="selectType('majorSubcategory')">
                                        <el-input
v-model="vo.majorSubcategory" v-listpage-dialog v-can-edit
                                            listviewurl="school.majors.list" dialog-title="选择专业"
                                            exclude-fields="createTime" retain-btns="" name="majorSubcategory"
                                            placeholder="请选择专业"
/>
                                    </div> -->
                                    <div>
                                        <!-- <el-input
v-model="vo.majorSubcategory" readonly name="majorSubcategory"
                                            placeholder="请先选择专业小类"
/> -->
                                        <span>{{ vo.majorSubcategory }}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_班级" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">班级</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div @click="selectType('className')">
                                        <el-input v-model="vo.className" v-listpage-dialog v-can-edit
                                            listviewurl="school.clazz.list" dialog-title="选择班级"
                                            exclude-fields="createTime" retain-btns="" name="className"
                                            placeholder="请选择班级" />
                                    </div>
                                    <!-- <div v-else>
                                        <el-input
v-model="vo.className" readonly name="majorSubcategory"
                                            placeholder="请先选择专业"
/>
                                    </div> -->
                                </td>
                                <td ref="tdlbl_入学时间" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'enrollmentDate'" class="field">入学时间</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="enrollmentDate"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '', errorMessage: null, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '入学时间', propName: 'enrollmentDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd', valueMaxLength: null, valueMinLength: null, tbFieldName: 'enrollmentdate', iconName: 'sjxzk', model: 'vo.enrollmentDate', option: [], formTdAlign: 'text-left', weekday: 0 }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_专业版本" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">专业版本</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit == 1">
                                        <el-date-picker v-model="vo.majorVersion" type="year" placeholder="请选择"
                                            size="small" style="width: 100%" value-format="yyyy" />
                                    </div>
                                    <div v-if="canEdit == 0">
                                        {{ vo.majorVersion }}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_民族" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'ethnicity'" class="field">民族</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="ethnicity" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter:
                                            '汉族：汉族\n满族：满族\n蒙古族：蒙古族\n回族：回族\n藏族：藏族\n维吾尔族：维吾尔族\n苗族：苗族\n彝族：彝族\n壮族：壮族\n布依族：布依族\n侗族：侗族\n瑶族：瑶族\n白族：白族\n土家族：土家族\n哈尼族：哈尼族\n哈萨克族：哈萨克族\n傣族：傣族\n黎族：黎族\n傈僳族：傈僳族\n佤族：佤族\n赫哲族：赫哲族\n畲族：畲族\n高山族：高山族\n拉祜族：拉祜族\n水族：水族\n东乡族：东乡族\n纳西族：纳西族\n景颇族：景颇族\n柯尔克孜族：柯尔克孜族\n土族：土族\n达斡尔族：达斡尔族\n仫佬族：仫佬族\n羌族：羌族\n布朗族：布朗族\n撒拉族：撒拉族\n毛南族：毛南族\n仡佬族：仡佬族\n锡伯族：锡伯族\n阿昌族：阿昌族\n普米族：普米族\n朝鲜族：朝鲜族\n塔吉克族：塔吉克族\n怒族：怒族\n乌孜别克族：乌孜别克族\n俄罗斯族：俄罗斯族\n鄂温克族：鄂温克族\n德昂族：德昂族\n保安族：保安族\n裕固族：裕固族\n京族：京族\n塔塔尔族：塔塔尔族\n独龙族：独龙族\n鄂伦春族：鄂伦春族\n门巴族：门巴族\n珞巴族：珞巴族\n基诺族：基诺族\n其他：其他',
                                        elementReadonly: 0,
                                        elementType: 'select',
                                        emptyMessage: '请输入民族',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '民族',
                                        propName: 'ethnicity',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 30,
                                        valueMinLength: null,
                                        model: 'vo.ethnicity',
                                        option: [
                                            { value: '汉族', name: '汉族' },
                                            { value: '满族', name: '满族' },
                                            { value: '蒙古族', name: '蒙古族' },
                                            { value: '回族', name: '回族' },
                                            { value: '藏族', name: '藏族' },
                                            { value: '维吾尔族', name: '维吾尔族' },
                                            { value: '苗族', name: '苗族' },
                                            { value: '彝族', name: '彝族' },
                                            { value: '壮族', name: '壮族' },
                                            { value: '布依族', name: '布依族' },
                                            { value: '侗族', name: '侗族' },
                                            { value: '瑶族', name: '瑶族' },
                                            { value: '白族', name: '白族' },
                                            { value: '土家族', name: '土家族' },
                                            { value: '哈尼族', name: '哈尼族' },
                                            { value: '哈萨克族', name: '哈萨克族' },
                                            { value: '傣族', name: '傣族' },
                                            { value: '黎族', name: '黎族' },
                                            { value: '傈僳族', name: '傈僳族' },
                                            { value: '佤族', name: '佤族' },
                                            { value: '畲族', name: '畲族' },
                                            { value: '高山族', name: '高山族' },
                                            { value: '拉祜族', name: '拉祜族' },
                                            { value: '水族', name: '水族' },
                                            { value: '东乡族', name: '东乡族' },
                                            { value: '纳西族', name: '纳西族' },
                                            { value: '景颇族', name: '景颇族' },
                                            { value: '柯尔克孜族', name: '柯尔克孜族' },
                                            { value: '土族', name: '土族' },
                                            { value: '达斡尔族', name: '达斡尔族' },
                                            { value: '仫佬族', name: '仫佬族' },
                                            { value: '羌族', name: '羌族' },
                                            { value: '布朗族', name: '布朗族' },
                                            { value: '撒拉族', name: '撒拉族' },
                                            { value: '毛南族', name: '毛南族' },
                                            { value: '仡佬族', name: '仡佬族' },
                                            { value: '锡伯族', name: '锡伯族' },
                                            { value: '阿昌族', name: '阿昌族' },
                                            { value: '普米族', name: '普米族' },
                                            { value: '朝鲜族', name: '朝鲜族' },
                                            { value: '塔吉克族', name: '塔吉克族' },
                                            { value: '怒族', name: '怒族' },
                                            { value: '乌孜别克族', name: '乌孜别克族' },
                                            { value: '俄罗斯族', name: '俄罗斯族' },
                                            { value: '鄂温克族', name: '鄂温克族' },
                                            { value: '德昂族', name: '德昂族' },
                                            { value: '保安族', name: '保安族' },
                                            { value: '裕固族', name: '裕固族' },
                                            { value: '赫哲族', name: '赫哲族' },
                                            { value: '京族', name: '京族' },
                                            { value: '塔塔尔族', name: '塔塔尔族' },
                                            { value: '独龙族', name: '独龙族' },
                                            { value: '鄂伦春族', name: '鄂伦春族' },
                                            { value: '门巴族', name: '门巴族' },
                                            { value: '珞巴族', name: '珞巴族' },
                                            { value: '基诺族', name: '基诺族' },
                                            { value: '其他', name: '其他' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: true,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_培养层次" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'educationLevel'" class="field">培养层次</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="educationLevel" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：中级\n1：中级\n2：高级\n3：预备技师\n4：技师',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '培养层次',
                                        propName: 'educationLevel',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'educationlevel',
                                        iconName: 'xialakuang',
                                        model: 'vo.educationLevel',
                                        option: [
                                            { name: '初级', value: '0' },
                                            { name: '中级', value: '1' },
                                            { name: '高级', value: '2' },
                                            { name: '预备技师', value: '3' },
                                            { name: '技师', value: '4' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_是否新型学徒" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>

                                    <span v-field-lbl="'isApprentice'" class="field">是否新型学徒</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="isApprentice" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：是\n1：否',
                                        elementReadonly: 0,
                                        elementType: 'radio',
                                        emptyMessage: '请选择是否新型学徒',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否新型学徒',
                                        propName: 'isApprentice',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 4,
                                        valueMinLength: null,
                                        model: 'vo.isApprentice',
                                        option: [
                                            { value: '0', name: '是' },
                                            { value: '1', name: '否' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_入学前技能水平" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'previousSkillLevel'" class="field">入学前技能水平</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="previousSkillLevel" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '无：无\n初级：初级\n中级：中级\n高级：高级\n预备技师：预备技师\n技师：技师',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '入学前技能水平',
                                        propName: 'previousSkillLevel',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'previousskilllevel',
                                        iconName: 'xialakuang',
                                        model: 'vo.previousSkillLevel',
                                        option: [
                                            { value: '无', name: '无' },
                                            { value: '初级', name: '初级' },
                                            { name: '中级', value: '中级' },
                                            { name: '高级', value: '高级' },
                                            { name: '预备技师', value: '预备技师' },
                                            { name: '技师', value: '技师' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_以前学历" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'previousEducation'" class="field">以前学历</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="previousEducation" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：本科\n1：大专\n2：中专\n3：高中\n4：技校\n5：职高\n6：初中',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '以前学历',
                                        propName: 'previousEducation',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'previouseducation',
                                        iconName: 'xialakuang',
                                        model: 'vo.previousEducation',
                                        option: [
                                            { value: '0', name: '本科' },
                                            { name: '大专', value: '1' },
                                            { name: '中专', value: '2' },
                                            { name: '高中', value: '3' },
                                            { name: '技校', value: '4' },
                                            { name: '职高', value: '5' },
                                            { name: '初中', value: '6' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_毕业学校" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'graduationSchool'" class="field">毕业学校</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="graduationSchool" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入毕业学校',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '毕业学校',
                                        propName: 'graduationSchool',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.graduationSchool',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_学习形式" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'studyForm'" class="field">学习形式</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="studyForm" :field="{
                                        defaultValue: '0',
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：全日制\n1：非全日制',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '请选择学习形式',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '学习形式',
                                        propName: 'studyForm',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.studyForm',
                                        option: [
                                            { value: '0', name: '全日制' },
                                            { value: '1', name: '非全日制' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_入学前毕业专业" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'previousMajorName'" class="field">入学前毕业专业</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="previousMajorName" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入入学前毕业专业',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '入学前毕业专业',
                                        propName: 'previousMajorName',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 255,
                                        valueMinLength: null,
                                        model: 'vo.previousMajorName',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_入学前毕业证号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'graduationCertificateNum'" class="field">入学前毕业证号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="graduationCertificateNum"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入入学前毕业证号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '入学前毕业证号', propName: 'graduationCertificateNum', propType: 'String', textFormatter: 'textfield', valueMaxLength: 255, valueMinLength: null, model: 'vo.graduationCertificateNum', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_入学前毕业专业级别" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'professionalLevel'" class="field">入学前毕业专业级别</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="professionalLevel" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '无：无\n中职：中职\n职高：职高\n中级技工：中级技工\n高中：高中\n大专：大专',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请输入入学前毕业专业级别',
                                        errorMessage: null,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '入学前毕业专业级别',
                                        propName: 'professionalLevel',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'professionallevel',
                                        iconName: 'xialakuang',
                                        model: 'vo.professionalLevel',
                                        option: [
                                            { value: '无', name: '无' },
                                            { value: '中职', name: '中职' },
                                            { name: '职高', value: '职高' },
                                            { name: '中级技工', value: '中级技工' },
                                            { name: '高中', value: '高中' },
                                            { name: '大专', value: '大专' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_是否家庭困难" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'isFamilyDifficult'" class="field">是否家庭困难</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="isFamilyDifficult" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '1：是\n0：否',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '请选择是否家庭困难',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否家庭困难',
                                        propName: 'isFamilyDifficult',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.isFamilyDifficult',
                                        option: [
                                            { value: '1', name: '是' },
                                            { value: '0', name: '否' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_家庭困难类型" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'familyDifficultyType'" class="field">家庭困难类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="familyDifficultyType" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：建档立卡家庭\n1：低保家庭\n2：特困供养\n3：孤残学生\n4：烈士子女\n5：家庭经济困难残疾学生及残疾人子女\n6：其他',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '家庭困难类型',
                                        propName: 'familyDifficultyType',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'familydifficultytype',
                                        iconName: 'xialakuang',
                                        model: 'vo.familyDifficultyType',
                                        option: [
                                            { value: '0', name: '建档立卡家庭' },
                                            { name: '低保家庭', value: '1' },
                                            { name: '特困供养', value: '2' },
                                            { name: '孤残学生', value: '3' },
                                            { name: '烈士子女', value: '4' },
                                            { name: '家庭经济困难残疾学生及残疾人子女', value: '5' },
                                            { name: '其他', value: '6' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_户口性质" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'hukouNature'" class="field">户口性质</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="hukouNature" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：城市\n1：农村\n2：县镇\n3：县城',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择户口性质',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '户口性质',
                                        propName: 'hukouNature',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.hukouNature',
                                        option: [
                                            { value: '0', name: '城市' },
                                            { value: '1', name: '农村' },
                                            { name: '县镇', value: '2' },
                                            { name: '县城', value: '3' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_户口所在地" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'householdRegistration'" class="field">户口所在地</span>
                                </td>
                                <td class="el-table__cell tdcont" colspan="1">
                                    <form-item ref="householdRegistration" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 1,
                                        elementType: 'input',
                                        emptyMessage: '请输入户口所在地',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '户口所在地',
                                        propName: 'householdRegistration',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 255,
                                        valueMinLength: null,
                                        model: 'vo.householdRegistration',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogType: 'area',
                                        dialogOrgLevel: '',
                                        dialogMultiple: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_籍贯" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'nativePlace'" class="field">籍贯</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="nativePlace" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入籍贯',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '籍贯',
                                        propName: 'nativePlace',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.nativePlace',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogType: 'area',
                                        dialogOrgLevel: '',
                                        dialogTitle: '选择籍贯'
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr v-if="false">
                                <td ref="tdlbl_户口所在地-省" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'nativePlaceProvince'" class="field">户口所在地-省</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="nativePlaceProvince" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入户口所在地-省',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '户口所在地-省',
                                        propName: 'nativePlaceProvince',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.nativePlaceProvince',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogType: 'area',
                                        dialogOrgLevel: '',
                                        dialogMultiple: false,
                                        dialogNLevelFilter: 1
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_户口所在地-市" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'nativePlaceCity'" class="field">户口所在地-市</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="nativePlaceCity" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入户口所在地-市',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '户口所在地-市',
                                        propName: 'nativePlaceCity',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.nativePlaceCity',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogType: 'area',
                                        dialogOrgLevel: '',
                                        dialogMultiple: false,
                                        dialogNLevelFilter: 2
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_户口所在地-县" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'nativePlaceCounty'" class="field">户口所在地-县</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="nativePlaceCounty" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入户口所在地-县',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '户口所在地-县',
                                        propName: 'nativePlaceCounty',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.nativePlaceCounty',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogType: 'area',
                                        dialogOrgLevel: '',
                                        dialogMultiple: false,
                                        dialogNLevelFilter: 3
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_家庭联系人姓名" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyContactName'" class="field">家庭联系人姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="familyContactName"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementType: 'input', emptyMessage: '请输入家庭联系人姓名', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '家庭联系人姓名', propName: 'familyContactName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.familyContactName', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_家庭联系人电话" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyContactPhone'" class="field">家庭联系人电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="familyContactPhone" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入家庭联系人电话',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '家庭联系人电话',
                                        propName: 'familyContactPhone',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.familyContactPhone',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_家庭地址" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyAddress'" class="field">家庭地址</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="familyAddress"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementType: 'input', emptyMessage: '请输入现居住地址', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '家庭地址', propName: 'familyAddress', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.familyAddress', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_资助申请类型" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'selfApplicationType'" class="field">资助申请类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="selfApplicationType" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：都不申请\n1：都申请\n2：只申请助学金\n3：只申请免学费',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '资助申请类型',
                                        propName: 'selfApplicationType',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'selfapplicationtype',
                                        iconName: 'xialakuang',
                                        model: 'vo.selfApplicationType',
                                        option: [
                                            { value: '0', name: '都不申请' },
                                            { name: '都申请', value: '1' },
                                            { name: '只申请助学金', value: '2' },
                                            { name: '只申请免学费', value: '3' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_家庭年总收入（元）" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyIncome'" class="field">家庭年总收入（元）</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="familyIncome" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入家庭年总收入（元）',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '家庭年总收入（元）',
                                        propName: 'familyIncome',
                                        propType: 'java.math.BigDecimal',
                                        textFormatter: 'number',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.familyIncome',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_家庭人均收入（元）" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'perCapitaIncome'" class="field">家庭人均收入（元）</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="perCapitaIncome" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementType: 'input',
                                        emptyMessage: '请输入家庭人均收入（元）',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '家庭人均收入（元）',
                                        propName: 'perCapitaIncome',
                                        propType: 'java.math.BigDecimal',
                                        textFormatter: 'number',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.perCapitaIncome',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_家庭经济来源" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyEconomicSource'" class="field">家庭经济来源</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="familyEconomicSource"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementType: 'input', emptyMessage: '请输入家庭经济来源', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '家庭经济来源', propName: 'familyEconomicSource', propType: 'String', textFormatter: 'textarea', valueMaxLength: null, valueMinLength: null, model: 'vo.familyEconomicSource', option: [], autosize: false }"
                                        :vo="vo" :can-edit="canEdit" :autosize="false" />
                                </td>
                                <td ref="tdlbl_办学点名称" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>

                                    <span v-field-lbl="'schoolName'" class="field">办学点名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="schoolName"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入办学点名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 8, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '办学点名称', propName: 'schoolName', propType: 'String', textFormatter: 'textfield', valueMaxLength: 255, valueMinLength: null, model: 'vo.schoolName', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_入学前毕业时间" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>

                                    <span v-field-lbl="'graduationTime'" class="field">入学前毕业时间</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="graduationTime"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请输入入学前毕业时间', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '入学前毕业时间', propName: 'graduationTime', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, model: 'vo.graduationTime', option: [], weekday: 0 }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_银行卡号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'bankAccount'" class="field">银行卡号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="bankAccount"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementType: 'input', emptyMessage: '请输入银行卡号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '银行卡号', propName: 'bankAccount', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.bankAccount', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_社保卡号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'socialSecurityNumber'" class="field">社保卡号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="socialSecurityNumber"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementType: 'input', emptyMessage: '请输入社保卡号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '社保卡号', propName: 'socialSecurityNumber', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.socialSecurityNumber', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_邮编" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'postalCode'" class="field">邮编</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="postalCode"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入邮编', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 8, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '邮编', propName: 'postalCode', propType: 'String', textFormatter: 'textfield', valueMaxLength: 10, valueMinLength: null, model: 'vo.postalCode', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_身体状况" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'healthStatus'" class="field">身体状况</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="healthStatus" key="healthStatus" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '健康：健康\n良好：良好',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择身体状况',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '身体状况',
                                        propName: 'healthStatus',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'healthStatus',
                                        iconName: 'xialakuang',
                                        model: 'vo.healthStatus',
                                        option: [
                                            { value: '健康', name: '健康' },
                                            { name: '良好', value: '良好' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_学生状态" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'basicInfoStatus'" class="field">学生状态</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="basicInfoStatus" key="basicInfoStatus" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '初中应届：初中应届\n初中往届：初中往届\n高中学历：高中学历\n中升高：中升高\n本校转读：本校转读\n中技毕业报读：中技毕业报读\n高技毕业报读：高技毕业报读\n职中毕业报读：职中毕业报读\n插班生：插班生\n五年制：五年制\n高升预备技师：高升预备技师\n3+X高考班：3+X高考班',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择学生状态',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '学生状态',
                                        propName: 'basicInfoStatus',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'basicInfoStatus',
                                        iconName: 'xialakuang',
                                        model: 'vo.basicInfoStatus',
                                        option: [
                                            { value: '初中应届', name: '初中应届' },
                                            { value: '初中往届', name: '初中往届' },
                                            { value: '高中学历', name: '高中学历' },
                                            { value: '中升高', name: '中升高' },
                                            { value: '本校转读', name: '本校转读' },
                                            { value: '中技毕业报读', name: '中技毕业报读' },
                                            { value: '高技毕业报读', name: '高技毕业报读' },
                                            { value: '职中毕业报读', name: '职中毕业报读' },
                                            { value: '插班生', name: '插班生' },
                                            { value: '五年制', name: '五年制' },
                                            { value: '高升预备技师', name: '高升预备技师' },
                                            { value: '3+X高考班', name: '3+X高考班' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_家庭出身" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>

                                    <span v-field-lbl="'familyBackground'" class="field">家庭出身</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="familyBackground" key="familyBackground" :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '经商：经商\n务农：务农\n打工：打工',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '家庭出身',
                                        propName: 'familyBackground',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'familyBackground',
                                        iconName: 'xialakuang',
                                        model: 'vo.familyBackground',
                                        option: [
                                            { value: '经商', name: '经商' },
                                            { name: '务农', value: '务农' },
                                            { name: '打工', value: '打工' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_兴趣爱好" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'hobbies'" class="field">兴趣爱好</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="hobbies"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'textarea', emptyMessage: '请输入兴趣爱好', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 8, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '兴趣爱好', propName: 'hobbies', propType: 'String', textFormatter: 'textarea', valueMaxLength: null, valueMinLength: null, model: 'vo.hobbies', option: [], autosize: false }"
                                        :vo="vo" :can-edit="canEdit" :autosize="false" />
                                </td>
                            </tr>
                            <tr>
                                <td class="el-table__cell tdcont tdcont-innertb" colspan="6">
                                    <div class="familyMembers_title">
                                        <div class="familyMembers_title_left">
                                            <span
                                                style="font-size: 14px; padding-left: 10px; margin-bottom: 10px">家庭成员</span>
                                        </div>
                                        <div v-if="canEdit === 1" style="display: flex; gap: 8px">
                                            <el-link type="primary" @click="importData">导入</el-link>
                                            <!-- <el-link icon="el-icon-add" type="primary" @click="addInnerTableFamilyMember">新增</el-link> -->
                                        </div>
                                    </div>
                                    <inner-table id="innerTable" ref="innerTable"
                                        :listviewurl="'studentFamilyMembers.list'" :exclude-fields="''"
                                        :link-prop-name="'studentBasicInfoId'" :can-edit="1" :can-delete="1"
                                        :form-type="formType" :can-add="1" :in-line-edit="0" :show-toolbar="0"
                                        :pagination="0" />
                                </td>
                            </tr>
                            <tr>
                                <td class="el-table__cell tdcont tdcont-innertb" colspan="6">
                                    <div class="familyMembers_title">
                                        <div class="familyMembers_title_left">
                                            <span
                                                style="font-size: 14px; padding-left: 10px; margin-bottom: 10px">其他监护人</span>
                                        </div>
                                    </div>
                                    <!-- <FamilyMembersList2 id="innerTable1" ref="innerTable1" :listviewurl="'studentFamilyMembers.list_zvn4zM'" :exclude-fields="''" :link-prop-name="'studentBasicInfoId'" :can-edit="1" :can-delete="1" :form-type="formType" :can-add="1" :in-line-edit="0" :show-toolbar="0" :pagination="0" /> -->
                                    <el-table :data="familyMembersList" border style="width: 100%"
                                        class="FamilyMembersList2" @row-click="rowClick">
                                        <el-table-column type="index" label="序号" align="center"></el-table-column>
                                        <el-table-column prop="familyMemberName" width="150" label="其他监护人姓名"
                                            align="center"></el-table-column>
                                        <el-table-column prop="idNumber" width="180" label="其他监护人证件号码"
                                            align="center"></el-table-column>
                                        <el-table-column prop="phone" label="其他监护人电话" align="left"></el-table-column>
                                        <el-table-column v-if="canEdit" prop="option" label="操作" align="center"
                                            width="70">
                                            <template slot="header" slot-scope="scope">
                                                <el-link icon="el-icon-plus" type="primary"
                                                    @click="addClick">新增</el-link>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-link icon="el-icon-edit" type="primary"
                                                    @click="editClick(scope.row)"></el-link>
                                                <el-link icon="el-icon-delete" type="primary"
                                                    @click="deleteClick(scope.row)"></el-link>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_是否三区三州学生" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'isThreeRegionsStudent'" class="field">是否三区三州学生</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="isThreeRegionsStudent" :field="{
                                        defaultValue: '否',
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：否\n1：是',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否三区三州学生',
                                        propName: 'isThreeRegionsStudent',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        tbFieldName: 'isthreeregionsstudent',
                                        iconName: 'dxk',
                                        model: 'vo.isThreeRegionsStudent',
                                        option: [
                                            { value: '0', name: '否' },
                                            { name: '是', value: '1' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_是否连片特困地区" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'isPoorArea'" class="field">是否连片特困地区</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="isPoorArea" :field="{
                                        defaultValue: '否',
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：否\n1：是',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否连片特困地区',
                                        propName: 'isPoorArea',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        tbFieldName: 'ispoorarea',
                                        iconName: 'dxk',
                                        model: 'vo.isPoorArea',
                                        option: [
                                            { value: '0', name: '否' },
                                            { name: '是', value: '1' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_是否合班" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'ifMerge'" class="field">是否合班</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="ifMerge"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{{canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': '否：否\n是：是', 'elementReadonly': null, 'elementType': 'radio', 'emptyMessage': '请选择是否合班', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '是否合班', 'propName': 'ifMerge', 'propType': 'String', 'textFormatter': null, 'valueMaxLength': 10, 'valueMinLength': null, 'model': 'vo.ifMerge', 'option': [{ 'value': '否', 'name': '否' }, { 'value': '是', 'name': '是' }] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <!-- <td ref="tdlbl_学生标识" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'studentIdentification'" class="field">学生标识</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="1">
                                    <form-item
ref="studentIdentification"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：非毕业离校\n1：校特困生\n2：烈属\n3：侨属','elementReadonly':1,'elementType':'select','emptyMessage':'请选择学生标识','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'学生标识','propName':'studentIdentification','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.studentIdentification','option':[{'value':'0','name':'非毕业离校'},{'value':'1','name':'校特困生'},{'value':'2','name':'烈属'},{'value':'3','name':'侨属'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td> -->
                            </tr>
                            <tr>
                                <td ref="tdlbl_是否烈属" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'ifLs'" class="field">是否烈属</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="ifLs" :field="{
                                        defaultValue: '否',
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '否：否\n是：是',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '请选择是否烈属',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否烈属',
                                        propName: 'ifLs',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 255,
                                        valueMinLength: null,
                                        model: 'vo.ifLs',
                                        option: [
                                            { value: '否', name: '否' },
                                            { value: '是', name: '是' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_是否侨属" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'ifQs'" class="field">是否侨属</span>
                                </td>
                                <td class="el-table__cell tdcont" colspan="1">
                                    <form-item ref="ifQs" :field="{
                                        defaultValue: '否',
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '否：否\n是：是',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '请选择是否侨属',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否侨属',
                                        propName: 'ifQs',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 255,
                                        valueMinLength: null,
                                        model: 'vo.ifQs',
                                        option: [
                                            { value: '否', name: '否' },
                                            { value: '是', name: '是' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_原班级名称" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'zyClassName'" class="field">原班级名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="zyClassName"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 0, 'elementType': 'input', 'emptyMessage': '请输入原班级名称', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '原班级名称', 'propName': 'zyClassName', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 100, 'valueMinLength': null, 'model': 'vo.zyClassName', 'option': [], 'autocomplete': 'off', 'dialog': 0, 'showWordLimit': false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_原专业小类" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'originMajorSubcategory'" class="field">原专业小类</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="originMajorSubcategory"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 0, 'elementType': 'input', 'emptyMessage': '请输入原专业小类', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 8, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '原专业小类', 'propName': 'originMajorSubcategory', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 255, 'valueMinLength': null, 'model': 'vo.originMajorSubcategory', 'option': [], 'autocomplete': 'off', 'dialog': 0, 'showWordLimit': false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_原专业大类" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'originMajorName'" class="field">原专业大类</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="originMajorName"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 0, 'elementType': 'input', 'emptyMessage': '请输入原专业大类', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 8, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '原专业大类', 'propName': 'originMajorName', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 255, 'valueMinLength': null, 'model': 'vo.originMajorName', 'option': [], 'autocomplete': 'off', 'dialog': 0, 'showWordLimit': false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_原院系" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'originMajorCategory'" class="field">原院系</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="originMajorCategory"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 0, 'elementType': 'input', 'emptyMessage': '请输入原院系', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 8, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '原院系', 'propName': 'originMajorCategory', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 255, 'valueMinLength': null, 'model': 'vo.originMajorCategory', 'option': [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr v-if="false">
                                <td ref="tdlbl_是否激活" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'activateStatus'" class="field">是否激活</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="5">
                                    <form-item ref="activateStatus" :field="{
                                        defaultValue: '',
                                        elementCanEdit: '0',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：未激活\n1：已激活',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '是否激活',
                                        propName: 'activateStatus',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        tbFieldName: 'activateStatus',
                                        iconName: 'dxk',
                                        model: 'vo.activateStatus',
                                        option: [
                                            { value: '0', name: '未激活' },
                                            { name: '已激活', value: '1' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }" :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_备注" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'remarks1'" class="field">备注</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item ref="remarks1"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementType: 'textarea', emptyMessage: '请输入备注', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '备注', propName: 'remarks1', propType: 'String', textFormatter: 'textarea', valueMaxLength: null, valueMinLength: null, model: 'vo.remarks1', option: [] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
        <div v-if="allowEdit" class="el_dialog_footer">
            <!-- <el-button v-if="canEdit == 0" type="primary" @click="update()">修改</el-button> -->
            <!-- <el-button v-if="canEdit == 1" type="info" @click="cancel()">取消</el-button>
            <el-button v-if="canEdit == 1" :loading="doing" type="primary" @click="handleSubmit">保存</el-button> -->
        </div>
        <el-dialog title="导入家庭成员" :visible.sync="showImport" :destroy-on-close="true" :close-on-click-modal="false"
            :width="'850'">
            <el-form>
                <div class="el-table el-table--fit el-table--border" style="width: 824px; margin-top: 10px">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="tdcont tdw83" colspan="6">
                                        <div class="row-col">
                                            <el-upload ref="upload" class="upload-demo" accept=".xls"
                                                :action="base_api + 'xsgl/studentFamilyMembers/importdata'"
                                                :data="uploadDdta" :multiple="false" :file-list="fileList"
                                                :on-change="fileChange" :on-remove="removeFile"
                                                :on-success="uploadSuccess" :auto-upload="false"
                                                :with-credentials="true" :show-file-list="true" :disabled="false"
                                                :limit="1">
                                                <el-button slot="trigger" type="text">选择文件</el-button>
                                            </el-upload>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="tdlbl tdw100" colspan="6">
                                        <div class="tip">
                                            <div class="light" @click="handleDownLoad">
                                                1、请先下载
                                                <span style="color: red; width: 100%">Excel导入示例；</span>
                                                <br />
                                            </div>
                                            <div class="light" style="cursor: default">
                                                2、导入文件应为Office Excel文件；
                                                <br />
                                                3、请点击【导入】按钮，按照提示上传；
                                                <br />
                                                4、导入文件暂不支持Office 2007及以后版本的Excel文件，如您使用的是Office
                                                2007及以后版本，请把Excel文件转换为2003或之前的版本格式，具体转换方式为：打开的Excel文件中，选择“另存为”->“Excel
                                                97-2003工作簿”；
                                                <br />
                                                5、进行导入操作时，请确保您导入的文件并未处于使用状态。
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain icon="el-icon-close" @click="showImport = false">关闭</el-button>
                <el-button type="primary" :disabled="doing" icon="el-icon-check" @click="startUpload">导入</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data: function () {
        return {
            // canEdit: 0,
            formType: '',
            familyMembersList: [],
            loginUser: this.$store.getters.loginUser,
            viewFile: false,
            doing: false,
            fileList: [],
            imageSrc: '',
            type: '',
            oldMajor: null,
            oldMajorSub: null,
            majorVersion: '',
            admissionYear: '',
            nativePlace: '',
            ethnicity: '',
            placeOptions: [
                {
                    label: '北京',
                    value: '1'
                },
                {
                    label: '天津',
                    value: '2'
                },
                {
                    label: '河北',
                    value: '3'
                },
                {
                    label: '山西',
                    value: '4'
                },
                {
                    label: '内蒙古',
                    value: '5'
                },
                {
                    label: '辽宁',
                    value: '6'
                },
                {
                    label: '吉林',
                    value: '7'
                },
                {
                    label: '黑龙江',
                    value: '8'
                },
                {
                    label: '上海',
                    value: '9'
                },
                {
                    label: '江苏',
                    value: '10'
                },
                {
                    label: '浙江',
                    value: '11'
                },
                {
                    label: '安徽',
                    value: '12'
                },
                {
                    label: '福建',
                    value: '13'
                },
                {
                    label: '江西',
                    value: '14'
                },
                {
                    label: '山东',
                    value: '15'
                },
                {
                    label: '河南',
                    value: '16'
                },
                {
                    label: '湖北',
                    value: '17'
                },
                {
                    label: '湖南',
                    value: '18'
                },
                {
                    label: '广东',
                    value: '19'
                },
                {
                    label: '广西',
                    value: '20'
                },
                {
                    label: '海南',
                    value: '21'
                },
                {
                    label: '重庆',
                    value: '22'
                },
                {
                    label: '四川',
                    value: '23'
                },
                {
                    label: '贵州',
                    value: '24'
                },
                {
                    label: '云南',
                    value: '25'
                },
                {
                    label: '西藏',
                    value: '26'
                },
                {
                    label: '陕西',
                    value: '27'
                },
                {
                    label: '甘肃',
                    value: '28'
                },
                {
                    label: '青海',
                    value: '29'
                },
                {
                    label: '宁夏',
                    value: '30'
                },
                {
                    label: '新疆',
                    value: '31'
                },
                {
                    label: '台湾',
                    value: '32'
                },
                {
                    label: '香港',
                    value: '33'
                },
                {
                    label: '澳门',
                    value: '34'
                }
            ],
            familyMembers: [],
            allowEdit: true,
            isAdmin: false,
            politicalStatusFormat: `0：中共党员\n1：中共预备党员\n2：共青团员\n3：民革会员\n4：民盟盟员\n5：民建会员\n6：民进会员\n7：农工党党员\n8：致公党党员\n9：九三学社社员\n10：台盟盟员\n11：无党派民主人士\n12：群众`,
            politicalStatusOption: [
                { value: '0', name: '中共党员' },
                { value: '1', name: '中共预备党员' },
                { value: '2', name: '共青团员' },
                { value: '3', name: '民革会员' },
                { value: '4', name: '民盟盟员' },
                { value: '5', name: '民建会员' },
                { value: '6', name: '民进会员' },
                { value: '7', name: '农工党党员' },
                { value: '8', name: '致公党党员' },
                { value: '9', name: '九三学社社员' },
                { value: '10', name: '台盟盟员' },
                { value: '11', name: '无党派民主人士' },
                { value: '12', name: '群众' }
            ],
            changeInnerTable: true,
            familySize: 0,
            showImport: false,
            base_api: '/apigw/',
            uploadDdta: {},
            fileList: [],
            isInnerTableFamilyMember: false
        }
    },
    computed: {},
    watch: {
        'vo.idCardNumber': {

            handler(val, oval) {
                console.log('watch idCardNumber', val, this.vo.studentFileId)
                this.vo.studentFileId = 'G' + val
                if (val) {
                    if (this.vo.idType === '0' || this.vo.idType === 0) {
                        let value = this.parseIDCard(val)
                        if (value.code === 'success') {
                            let result = this.parseIDCard(val)
                            if (result.code === 'success') {
                                // if (this.vo.gender == '' || this.vo.gender == null) this.vo.gender = result.value.gender
                                // if (this.vo.birthDate == '' || this.vo.birthDate == null) this.vo.birthDate = result.value.birthDate
                                // if (this.vo.age == '' || this.vo.age == null) this.vo.age = result.value.age
                                this.vo.gender = result.value.gender || this.vo.gender
                                this.vo.birthDate = result.value.birthDate || this.vo.birthDate
                                this.vo.age = result.value.age || this.vo.age
                            }
                        }
                    }
                }
            }
        }
    },
    async created() {
        if (this.$store.getters.roles.indexOf('dwAdministrators') !== -1) {
            this.isAdmin = true
        }
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }
        if (this.isAdmin) {
            this.allowEdit = true
        } else {
            this.allowEdit = await this.getConfig()
        }

        let str = `${this.vo.nativePlaceProvince ? this.vo.nativePlaceProvince : ''}${this.vo.nativePlaceCity ? '-' + this.vo.nativePlaceCity : ''}${this.vo.nativePlaceCounty ? '-' + this.vo.nativePlaceCounty : ''}`
        this.$set(this.vo, 'hkszd', str)

        this.$set(this.$vnode.context, 'wfAttach', false)

        this.oldMajor = this.vo.majorCategory
        this.oldMajorSub = this.vo.majorSubcategory
        if (this.vo.idPhoto) {
            this.viewFile = true
        }

        if (this.vo?.id) {
            this.$http({
                method: 'post',
                url: 'xsgl/studentFamilyMembers/listdata',
                params: {
                    urlsearch: `studentBasicInfoId:${this.vo?.id}`
                }
            }).then((res) => {
                console.log('1220获取家庭成员列表成功！', res)
                if (res.code === 'success') {
                    this.familyMembers = res.body.pageInfo.list
                    console.log(this.familyMembers, 'this.familyMembers')
                }
            })
            this.getFamilyMembersList()
        }
        if (this.vo.householdRegistration) {
            this.$set(this.vo, 'householdRegistrationLabel', this.vo.householdRegistration.split('-').join(''))
        }
        if (this.vo.nativePlace) {
            // this.$set(this.vo, 'nativePlaceLabel', this.vo.nativePlace.split('-').join(''))
            this.$set(this.vo, 'nativePlace', this.vo.nativePlace.split('-').join(''))
        }
    },
    beforeDestroy: function () { },
    mounted: function () {
        // this.imageSrc = `${location.origin}${process.env.VUE_APP_BASE_API}/xsgl/studentBasicInfo/download?dataField=idPhoto&nameField=photoUrl&id=${this.vo.id}&httpPort=${location.port}`
        this.oldMajor = this.vo.majorCategory
        this.oldMajorSub = this.vo.majorSubcategory
    },
    methods: {
        handleUploadChange(filed, fileList) {
            if (filed.name.indexOf('.jpg') === -1 && filed.name.indexOf('.png') === -1 && filed.name.indexOf('.JPG') === -1 && filed.name.indexOf('.PNG') === -1) {
                this.$alert('上传文件格式错误', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return
            }
            filed.id = this.vo.id
            this.$set(this.vo, 'idPhoto', filed.name)
            this.vo.idPhoto = filed.name
            // file 源文件
            this.vo.idPhotoFile = fileList
            this.fileList = fileList
            console.log(this.fileList, 'fileList')
            console.log(filed, 'filed')
            // this.viewFile = true
        },
        upLoadImage() {
            console.log('上传图片！', this.fileList[0].raw)
            // this.$app.upload('/xsgl/studentBasicInfo/upload', this.fileList[0].raw, {
            //     'id': this.fileList[0].id,
            //     'nameField': 'photoUrl',
            //     'dataField': 'idPhoto'
            // }).then(res => {
            //     console.log('上传成功！', res)
            //     if (res.code == 'success') {
            //         this.$message({
            //             type: 'success',
            //             message: '保存成功！'
            //         })
            //     } else {
            //         this.$message.error('文件保存失败！')
            //     }
            // })

            // this.$app.upload('/xsgl/studentBasicInfo/upFacePhotos', {
            //     file: this.fileList[0].raw,
            //     isAddBaiDuFace: true
            // }).then(res => {
            //     console.log('上传成功！', res)
            //     if (res.code == 'success') {
            //         this.$message({
            //             type: 'success',
            //             message: '保存成功！'
            //         })
            //     } else {
            //         this.$message.error('文件保存失败！')
            //     }
            // })
        },
        onBasicFormBeforeSubmit: function ($scope, vo, defer) {
            console.log('启动啦，onBasicFormBeforeSubmit')
            // this.$app.upload('/xsgl/studentBasicInfo/upFacePhotos', {
            //     file: this.fileList[0].raw,
            //     isAddBaiDuFace: true
            // }).then(res => {
            //     console.log('上传成功！', res)
            //     if (res.code == 'success') {
            //         this.$message({
            //             type: 'success',
            //             message: '保存成功！'
            //         })
            //     } else {
            //         this.$message.error('文件保存失败！')
            //     }
            // })
        },
        update() {
            this.canEdit = 1
            this.$vnode.context.$vnode.context.$vnode.context.canEdit = 1
        },
        cancel() {
            this.canEdit = 0
            this.$vnode.context.$vnode.context.$vnode.context.canEdit = 0
        },
        handleSubmit() {
            this.doing = true
            this.$http({
                method: 'put',
                url: '/xsgl/studentBasicInfo/update',
                data: this.vo
            }).then((res) => {
                console.log('更新成功！', this.fileList)

                if (res.code == 'success') {
                    this.$message({
                        type: 'success',
                        message: '保存成功！'
                    })
                    this.canEdit = 0
                    this.$vnode.context.$vnode.context.$vnode.context.canEdit = 0
                    this.$bus.emit('changeEdit', 0)
                    if (this.fileList.length > 0) {
                        this.upLoadImage()
                    }
                    //window.close();
                }
                this.doing = false
            })
        },

        // onBasicFormBeforeSubmit: function ($scope, vo, defer) {
        //     console.log('basicInfo form submit validation success')
        //     if (!vo.studentFileStatus) {
        //         vo.studentFileStatus = '0'
        //     }
        //     if (!vo.majorCategoryId) {
        //         //this.$message({
        //         //    type: 'warning',
        //         //    message: '请选择院系'
        //         //})
        //         //defer.reject(reason)
        //         //return
        //     } else if (!vo.majorSubcategoryId) {
        //         this.$message({
        //             type: 'warning',
        //             message: '请选择专业'
        //         })
        //         defer.reject(reason)
        //         return
        //     } else if (!vo.classId) {
        //         this.$message({
        //             type: 'warning',
        //             message: '请选择班级'
        //         })
        //         defer.reject(reason)
        //         return
        //     } else {
        //         defer.resolve(true)
        //     }
        // },
        onBasicFormSubmited: function ($scope, vo) {
            console.log('启动啦，onBasicFormSubmited')
            console.log('basicInfo form submit validation success')
            if (this.fileList.length > 0) {
                this.upLoadImage()
            }
            this.canEdit = 0
            //window.close();
        },
        versionChange: function (val) {
            this.$set(this.vo, 'majorVersion', this.majorVersion)
        },
        yearChange: function (val) {
            this.$set(this.vo, 'admissionYear', this.admissionYear)
        },
        selectType(type) {
            this.type = type
        },
        onSelectTreeNodeCompleted(node, attr) {
            if (attr.name === 'householdRegistration') {
                // householdRegistration
                this.vo.nativePlaceProvince = ''
                this.vo.nativePlaceCity = ''
                this.vo.nativePlaceCounty = ''
                let nodeList = node[0].fullName.split('-')
                if (node[0].nLevel == 1) {
                    this.$set(this.vo, 'nativePlaceProvince', nodeList[0])
                }
                if (node[0].nLevel == 2) {
                    this.$set(this.vo, 'nativePlaceProvince', nodeList[0])
                    this.$set(this.vo, 'nativePlaceCity', nodeList[1])
                }
                if (node[0].nLevel == 3) {
                    this.$set(this.vo, 'nativePlaceProvince', nodeList[0])
                    this.$set(this.vo, 'nativePlaceCity', nodeList[1])
                    this.$set(this.vo, 'nativePlaceCounty', nodeList[2])
                }
                this.$set(this.vo, 'householdRegistration', nodeList.join(''))
            }
            if (attr.name === 'nativePlace') {
                let nodeList = node[0].fullName.split('-')
                this.$set(this.vo, 'nativePlace', nodeList.join(''))
            }
            if (attr.name === 'hkszd') {
                this.vo.nativePlaceProvince = ''
                this.vo.nativePlaceCity = ''
                this.vo.nativePlaceCounty = ''
                let nodeList = node[0].fullName.split('-')
                if (node[0].nLevel == 1) {
                    this.$set(this.vo, 'nativePlaceProvince', nodeList[0])
                }
                if (node[0].nLevel == 2) {
                    this.$set(this.vo, 'nativePlaceProvince', nodeList[0])
                    this.$set(this.vo, 'nativePlaceCity', nodeList[1])
                }
                if (node[0].nLevel == 3) {
                    this.$set(this.vo, 'nativePlaceProvince', nodeList[0])
                    this.$set(this.vo, 'nativePlaceCity', nodeList[1])
                    this.$set(this.vo, 'nativePlaceCounty', nodeList[2])
                }
                this.$set(this.vo, 'hkszd', nodeList.join(''))
            }
            if (attr.name === 'nativePlaceProvince') {
                this.$set(this.vo, 'nativePlaceProvince', node[0].name)
            }
            if (attr.name === 'nativePlaceCity') {
                this.$set(this.vo, 'nativePlaceCity', node[0].name)
            }
            if (attr.name === 'nativePlaceCounty') {
                this.$set(this.vo, 'nativePlaceCounty', node[0].name)
            }
        },
        onDialogListDataBeforeLoad($scope, qparams) {
            // console.log('onDialogListDataBeforeLoad', $scope)
            // qparams.urlsearch = ''
            // if (this.type == 'className') {
            //     if (this.vo.majorSubcategory) {
            //         qparams.urlsearch = 'schoolMajorsId:' + this.vo.majorSubcategoryId
            //     } else {
            //         this.$message({
            //             type: 'warning',
            //             message: '请先选择专业！'
            //         })
            //         return
            //     }
            // } else if (this.type == 'majorSubcategory') {
            //     if (this.vo.majorId) {
            //         qparams.urlsearch = 'parentId:' + this.vo.majorId
            //     } else {
            //     }
            // } else if (this.type == 'majorName') {
            //     if (this.vo.majorCategoryId) {
            //     } else {
            //     }
            // }
        },

        onSelectListpageRowCompleted(val, attr) {
            if (attr.name == 'majorCategory') {
                // 选择院系
                this.$set(this.vo, 'majorCategory', val[0].majorName)
                this.$set(this.vo, 'majorCategoryId', val[0].id)

                // this.vo.majorSubcategory = ''
                // this.vo.majorSubcategoryId = ''
                //this.vo.majorName = ''
                //this.vo.majorId = ''
                // this.vo.className = ''
                // this.vo.classId = ''
                // this.vo.classCode = ''
            }
            if (attr.name == 'majorSubcategory') {
                // 选择小类
                this.$set(this.vo, 'majorSubcategory', val[0].majorName)
                this.$set(this.vo, 'majorSubcategoryId', val[0].id)

                this.vo.className = ''
                this.vo.classId = ''
                this.vo.classCode = ''
            } else if (attr.name == 'majorName') {
                // 选择大类
                this.$set(this.vo, 'majorName', val[0].majorName)
                this.$set(this.vo, 'majorId', val[0].id)

                this.vo.majorSubcategory = ''
                this.vo.majorSubcategoryId = ''
                this.vo.className = ''
                this.vo.classId = ''
                this.vo.classCode = ''
            } else if (attr.name == 'className') {
                // 选择班级
                this.$set(this.vo, 'classCode', val[0].classId)
                this.$set(this.vo, 'classId', val[0].classId)
                this.$set(this.vo, 'className', val[0].className)
                this.$set(this.vo, 'majorName', val[0].passenger.majorName)
                this.$set(this.vo, 'majorId', val[0].passenger.majorId)
                this.$set(this.vo, 'majorSubcategory', val[0].passenger.majorSubcategory)
                this.$set(this.vo, 'majorSubcategoryId', val[0].passenger.majorSubcategoryId)
                this.$set(this.vo, 'majorCategory', val[0].passenger.majorCategory)
                this.$set(this.vo, 'majorCategoryId', val[0].passenger.majorCategoryId)
            }
        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentBasicInfoId:${this.vo?.id};relationship!:14`
        },
        // 内嵌子表-子表单提交前回调
        onInnerBasicFormBeforeSubmit($scope, vo, defer) {
            console.log($scope.moduleInfo, 'onInnerBasicFormBeforeSubmit')
            vo.studentId = this.vo.studentId
            defer.resolve(true)
        },
        addfamilyMembers() {
            this.$http({
                method: 'POST',
                url: '/xsgl/studentFamilyMembers/addNew'
            }).then((res) => {
                if (res.code === 'success') {
                    this.vo.passenger.familyMembers.push(res.body.vo)
                }
            })
        },
        getFamilyMembersList() {
            if (this.vo?.id) {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/xsgl/studentFamilyMembers/listdata`,
                    method: 'POST',
                    params: {
                        listpageViewUrl: 'studentFamilyMembers.list',
                        urlsearch: `studentBasicInfoId:${this.vo?.id};relationship:14`
                    }
                }).then((res) => {
                    console.log('1504获取家庭成员列表成功！', res)
                    if (res.code === 'success') {
                        this.familyMembersList = res.body.pageInfo.list
                    }
                })
            }
        },
        addClick() {
            var _this = this
            this.$refs.innerTable.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/student/familyMembers/form_guP4Wv.html'
            this.$refs.innerTable.formTitle = '其他监护人'
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', this.$refs.innerTable.moduleInfo, null, 1, (res) => {
                    if (res.code === 'success') {
                        this.getFamilyMembersList()
                        this.$message({ type: 'success', message: '处理成功!' })
                    }
                    this.$refs.innerTable.formTitle = '家庭成员'
                    this.$refs.innerTable.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/student/familyMembers/form.html'
                })
            })
        },
        editClick(row) {
            var _this = this
            this.$refs.innerTable.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/student/familyMembers/form_guP4Wv.html'
            this.$refs.innerTable.formTitle = '其他监护人'
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', this.$refs.innerTable.moduleInfo, row, 1, (res) => {
                    this.$refs.innerTable.formTitle = '家庭成员'
                    this.$refs.innerTable.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/student/familyMembers/form.html'
                    if (res.code === 'success') {
                        this.getFamilyMembersList()
                        this.$message({ type: 'success', message: '处理成功!' })
                    }
                })
            })
        },
        rowClick(row, column) {
            console.log('column', column)
            if (column.property === 'option') return

            var _this = this
            this.$refs.innerTable.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/student/familyMembers/form_guP4Wv.html'
            this.$refs.innerTable.formTitle = '其他监护人'
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', this.$refs.innerTable.moduleInfo, row, 0, (res) => {
                    this.$refs.innerTable.formTitle = '家庭成员'
                    this.$refs.innerTable.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/student/familyMembers/form.html'
                    if (res.code === 'success') {
                        this.getFamilyMembersList()
                        this.$message({ type: 'success', message: '处理成功!' })
                    }
                })
            })
        },
        deleteClick(row) {
            this.$confirm('您是否确认删除选择的数据?', '操作提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$http({
                        contentType: 'application/x-www-form-urlencoded',
                        url: `/xsgl/studentFamilyMembers/delete`,
                        method: 'DELETE',
                        params: {
                            ids: row.id
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message({ type: 'success', message: '删除成功!' })
                            this.getFamilyMembersList()
                        }
                    })
                })
                .catch(() => {
                    //
                })
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.familyMembers = this.vo.passenger.familyMembers.filter((item) => item.id !== row.id)
        },
        async getConfig(callback) {
            debugger
            const _this = this
            const result = await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: '/base/paramConfig/findParamValueByName',
                params: {
                    orgCode: this.loginUser.orgCode,
                    paramName: 'student.edit.info'
                }
            })
            if (result.code === 'success') {
                if (result.body.value) {
                    const paramsArr = result.body.value.split('_')
                    const type = paramsArr[0]
                    // 格式：0_2025-05-01_2025-05-30。注：1允许，不限时间 2允许，指定时间 0禁止
                    if (type == 1) {
                        return true
                    } else if (type == 0) {
                        return false
                    } else if (type == 2) {
                        let startTime = paramsArr[1] + ' 00:00:00'
                        let endTime = paramsArr[2] + ' 23:59:59'
                        let currentTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                        if (new Date(startTime).getTime() < new Date(currentTime).getTime() && new Date(endTime).getTime() > new Date(currentTime).getTime()) {
                            return true
                        } else {
                            return false
                        }
                    }
                } else {
                    if (this.$store.getters.roles.indexOf('dwAdministrators') !== -1) {
                        return true
                    } else {
                        return false
                    }
                }
            } else {
                if (this.$store.getters.roles.indexOf('dwAdministrators') !== -1) {
                    return true
                } else {
                    return false
                }
            }
        },
        parseIDCard(idCard) {
            // 统一转为大写并去除空格
            idCard = idCard.toUpperCase().trim()

            // 基础校验
            if (!/^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(idCard)) {
                // throw new Error('身份证格式不正确');
                return { code: 'error' }
            }

            // 提取信息
            const birthDateStr = idCard.slice(6, 14)
            const genderCode = parseInt(idCard.charAt(16), 10) // 第17位（索引16）

            // 解析出生日期
            const year = parseInt(birthDateStr.slice(0, 4), 10)
            const month = parseInt(birthDateStr.slice(4, 6), 10) - 1 // 月份从0开始
            const day = parseInt(birthDateStr.slice(6, 8), 10)
            const birthDate = new Date(year, month, day)

            // 计算年龄
            const today = new Date()
            let age = today.getFullYear() - birthDate.getFullYear()
            if (today.getMonth() < birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
                age--
            }

            // 获取性别
            const gender = genderCode % 2 === 0 ? '1' : '0'

            return {
                code: 'success',
                value: {
                    birthDate: `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
                    age: age,
                    gender: gender
                }
            }
        },
        onInnerFormBeforeOpen($scope, vo, defer) {
            const { isnew } = $scope

            console.log('这里有个log---------------onInnerFormBeforeOpen-----------------')
            console.log($scope)
            console.log($scope.moduleInfo.moduleCode)

            console.log(isnew, this.familySize)
            console.log('---------------------------------', isnew)
            if (this.familySize >= 5 && isnew && this.isInnerTableFamilyMember) {
                this.$message.error('家庭成员人数请勿超过5人')
                defer.resolve(false)
                return
            }
            defer.resolve(true)
        },
        // 内嵌子表-加载数据后回调
        onInnerTableListDataLoaded($scope, pageInfo) {
            console.log('这里有个log------------onInnerTableListDataLoaded--------------------')
            console.log($scope)
            console.log(pageInfo)
            console.log('---------------------------------')
            const { size } = pageInfo
            this.familySize = size
        },
        // 刷新家庭成员表单
        refreshList() {
            this.$bus.emit('refreshListData')
        },
        addInnerTableFamilyMember() {
            this.isInnerTableFamilyMember = true
            this.$refs.innerTable.$refs.innerListTable.addObject()
            console.log('这里有个log---------------this.$refs.innerTable-----------------')
            console.log('---------------------------------')
        },
        importData() {
            this.uploadDdta.studentId = this.vo?.studentId
            this.showImport = true
        },
        // 选择文件
        fileChange: function (file, files) {
            this.fileList = [file]
            this.doing = false
        },
        //删除文件
        removeFile: function (file, files) {
            this.fileList = []
        },
        uploadSuccess: function (response, file, fileList) {
            this.showImport = true
            if (response.code === 'success') {
                this.showImport = false
                this.$alert(response.message, '操作提示', { dangerouslyUseHTMLString: true })
                this.$bus.emit('refreshListData')
                this.getFamilyMembersList()
                if (response.body.listdata) {
                    this.$bus.emit('refreshTreeData', response.body.listdata)
                }
            } else {
                this.$alert(response.message, '操作提示', { type: 'error' })
            }
            this.doing = false
            this.fileList = null
            this.$nextTick(() => {
                this.fileList = []
            })
        },
        handleDownLoad() {
            this.fileDownload('/templates/学生家庭成员导入模板.xls')
            return
        },
        // 导入
        startUpload: function () {
            this.showImport = true
            if (this.fileList.length === 0) {
                this.$alert('请选择导入文件', '操作提示', { type: 'warning' })
            } else {
                this.doing = true
                this.$refs.upload.submit()
            }
        },
        /**
         * 检查成绩重复
         * studentExamScoresLog/listdata
         */
        inspectRepeat: async function (classId, schoolYear, semester, callback) {
            var searchMap = {}
            searchMap['schoolYear'] = this.exportObj.schoolYear
            searchMap['classId'] = this.exportObj.classId
            searchMap['semester'] = this.exportObj.semester
            const data = {
                pageNum: 1,
                pageSize: 1,
                searchAndOr: 'and',
                searchMap: searchMap
            }
            const res = await this.$app.listdata('xsgl/studentExamScoresLog/listdata', data)
            console.log('成绩单列表', res)
            if (res.body.pageInfo.endRow != 0) {
                this.$confirm('你已导入过班级成绩，多次导入可能会产生重复数据，请确认是否导入。', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    callback()
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.FamilyMembersList2 {
    border: none;

    &::before {
        background-color: #fff !important;
    }

    &::after {
        background-color: #fff !important;
    }
}

.el_dialog_footer {
    padding-top: 20px;
    display: flex;
    justify-content: center;
}

.familyMembers_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f2f5fb;
    border-top: 1px solid #e3e8ee;
    border-bottom: 1px solid #999;
    padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}

.upload /deep/.el-upload {
    width: 100% !important;
}
</style>
